import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../slices/index";
import { toastMiddleware } from "../middleware/toastMiddleware";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Browse keeps raw File/Blob on uploadFiles for Share-style chunked upload.
      serializableCheck: {
        ignoredActions: ["ON_FILEUPLOAD_CHANGE", "checkinApi/checkinDocument/pending", "checkinApi/checkinDocumentsBulk/pending"],
        ignoredActionPaths: [
          "payload.0.file",
          "meta.arg.uploadFiles",
          "meta.arg.documents",
          "payload",
        ],
        ignoredPaths: ["CheckinDocument.basicInfo.uploadFiles"],
      },
    }).concat(toastMiddleware),
});

export default store;